<template>
  <view class="scroll-text">
    <image src="https://ut-static.udache.com/webx/ut/gUdI6BekwFK6ILClO793O.png" class="icon"></image>
    <view class="scroll-content">
      <view class="marquee_text" style="transform: translateX(-{{marqueeDistance}}px)">
        <text class="text">{{text}}</text>
        <text class="text-placeholder">{{text}}</text>
      </view>
    </view>
  </view>
</template>

<script>
import mpx, { createComponent } from '@mpxjs/core'

createComponent({
  properties: {
    text: String,
  },
  data: {
    marqueeDistance: 0,
    timer: null,
  },
  ready() {
    this.scroll()
  },
  methods: {
    scroll() {
      // mpx.createSelectorQuery().in(this).select('.scroll-content').boundingClientRect(resC => {
      //   mpx.createSelectorQuery().in(this).select('.text').boundingClientRect(res => {
      //     this.isMoreText = res.width > resC.width
      //     if (!this.isMoreText) {
      //       return
      //     }
      //     this.timer = setInterval(() => {
      //       if (this.marqueeDistance >= res.width) {
      //         this.marqueeDistance = 0
      //       }
      //       this.marqueeDistance ++
      //     }, 30)
      //   }).exec()
      // }).exec()
      mpx.createSelectorQuery().in(this).select('.text').boundingClientRect(res => {
        this.timer = setInterval(() => {
          if (this.marqueeDistance >= res.width) {
            this.marqueeDistance = 0
          }
          this.marqueeDistance ++
        }, 30)
      }).exec()
    },
 },
 detached() {
   clearInterval(this.timer)
 },
})
</script>

<style lang="stylus" scoped>
span {
  white-space: unset
}
.scroll-text
  display flex
  justify-content center
  align-items center
  margin 30rpx auto 40rpx auto
  width 680rpx
  height 54rpx
  background #FF9D42
  box-shadow inset 0rpx 1rpx 6rpx 0rpx rgba(186,100,19,0.25)
  border-radius 16rpx
  font-family PingFangSC-Regular
  font-size 22rpx
  color #FFFFFF
  letter-spacing 1rpx
  font-weight 400
  .icon
    width 28rpx
    height 24rpx
    margin-right: 8rpx;
.scroll-content
  position:relative;
  display:block;
  overflow:hidden;
  width 598rpx
  white-space: nowrap;
  .text
    padding-right 10rpx
</style>

<script type="application/json" lang="json">
{
  "component": true,
  "usingComponents": {}
}
</script>
